import {Component, OnInit} from '@angular/core';
import {Enterprise} from '../../../model/Enterprise';
import {Page} from '../../../../global/util/enum/Page';
import {InformType} from '../../../../global/util/enum/InformType';
import {Constant} from '../../../../global/util/Constant';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../service/auth/auth.service';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Siecredential} from '../../../model/Siecredential';
import {SieCredentialService} from '../../../service/sie-credential.service';
import {AddSieCredentialComponent} from '../add-sie-credential/add-sie-credential.component';
import {Partner} from '../../../model/Partner';
import {Dialog} from '../../../../global/util/Dialog';
import {TranslateService} from '@ngx-translate/core';
import {Pagination} from '../../../../global/util/Pagination';
import {EnterpriseService} from '../../../service/enterprise.service';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';

@Component({
  selector: 'app-list-sie-credential',
  templateUrl: './list-sie-credential.component.html',
  styleUrls: ['./list-sie-credential.component.css']
})
export class ListSieCredentialComponent implements OnInit {
  private entityName = 'TITLE.SIE-CREDENTIAL';
  public title = this.entityName;
  public siecredentials: Siecredential[] = [];
  public enterprises: Enterprise[] = [];
  public enterpriseIdSelected: number;
  public page: any = {};
  public links: any = {};
  private siecredentialUrl: string;
  public enumPage = Page;
  public loading: boolean;
  public enterpriseSelected: Enterprise;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public ROLE_USER = Constant.ROLE_USER;
  public partnerSelected: Partner;
  public partners: Partner[] = [];
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(public sieCredentialService: SieCredentialService,
              private modalService: NgbModal,
              public authenticationService: AuthService,
              public enterpriseService: EnterpriseService,
              public enterpriseDataService: EnterpriseDataService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit() {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
    this.enterprises = LocalStorage.getDefaultEnterprise();
    this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
    this.enterpriseIdSelected = this.enterpriseSelected.id;
    this.loadDefaultData();
  }

  private loadDefaultData() {
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = LocalStorage.getPartners();
      this.partnerSelected = this.partners[Constant.ZERO_INDEX];
      this.getAllEnterprisesBy();
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      const partnerId = LocalStorage.getPartnerId();
      this.getEnterprisesByPartner(partnerId);
    } else {
      this.enterpriseIdSelected = LocalStorage.getEnterpriseIdView();
      // this.loadCredentials(Page.First);
    }
    this.loadCredentials(Page.First);
  }

  public reloadSiecredentials() {
    this.enterpriseIdSelected = this.enterpriseSelected.id;
    this.loadCredentials(Page.First);
  }

  public loadCredentials(page: Page): void {
    let partnerId;
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      partnerId = this.partnerSelected.id;
    } else {
      partnerId = LocalStorage.getPartnerId();
    }
    switch (page) {
      case Page.First:
        this.siecredentialUrl = Constant.ROOT_API_V1
          .concat('/partners/')
          .concat(String(partnerId))
          .concat('/enterprises/')
          .concat(String(this.enterpriseIdSelected))
          .concat('/siecredentials');
        break;
      case Page.Previous:
        this.siecredentialUrl = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        this.siecredentialUrl = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        this.siecredentialUrl = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        this.siecredentialUrl = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.getSiecredentials(this.siecredentialUrl);
  }

  private getSiecredentials(url: string) {
    this.loading = true;
    this.sieCredentialService.get(url).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.siecredentials = next._embedded.siecredentials;
      } else {
        this.siecredentials = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.loading = false;
      this.title = this.translate.instant('TITLE.SIE-CREDENTIAL');
      if (HttpStatusCode.UNAUTHORIZED === error.error.status) {
        Dialog.show(InformType.Danger, this.entityName, error.error.message);
      } else {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  public openAddModal() {
    this.loading = true;
    this.loading = false;
    const modalRef = this.modalService.open(AddSieCredentialComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.componentInstance.siecredential = new Siecredential();
    modalRef.result.then((result) => {
      this.title = this.translate.instant('TITLE.SIE-CREDENTIAL');
      if (InformType.Success === result) {
        this.loadCredentials(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  public hasRole(name: string): boolean {
    return this.authenticationService.hasRole(name);
  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }

  public reloadSiecredentials0() {
    this.getEnterpriseBy(this.partnerSelected.id);
  }

  private getAllEnterprisesBy() {
    this.enterpriseService.getAllEnterprises().subscribe(enterprises => {
      this.enterpriseDataService.setEnterprises(enterprises.sort());
      const enterpriseFilter = enterprises.filter(value => value.partnerId === this.partnerSelected.id);
      this.enterprises = LocalStorage.addEnterprise(enterpriseFilter).sort();
      if (this.enterprises.length > 0) {
        this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
        this.enterpriseIdSelected = this.enterpriseSelected.id;
      }
    });
  }

  private getEnterprisesByPartner(partnerId: number) {
    this.enterpriseService.getEnterprisesByPartner(partnerId).subscribe(enterprises => {
      this.enterpriseDataService.setEnterprises(enterprises.sort());
      this.enterprises = enterprises.sort();
      this.enterpriseDataService.setEnterprises(enterprises);
      if (this.enterprises.length > 0) {
        this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
        this.enterpriseIdSelected = this.enterpriseSelected.id;
      }
    });
  }

  /**
   * Filtra la empresa al seleccionar el partner
   * @param id
   * @private
   */
  private getEnterpriseBy(id: number): void {
    const enters = this.enterpriseDataService.getEnterprises();
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      if (id === Constant.ALL_PARTNER_ID) {
        this.enterprises = LocalStorage.getDefaultEnterprise();
      }
      const enterprisesFilter = enters.filter(value => id === value.partnerId);
      this.enterprises = LocalStorage.addEnterprise(enterprisesFilter);
      this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
      this.enterpriseIdSelected = this.enterpriseSelected.id;
      this.reloadSiecredentials();
    }
  }
}
